import { z } from "zod";
import { TargetSeasonSchema } from "./http.js";
/**
 * WHAT A MAIL LINK OPENS (CME stage 3b, 2026-10-11; split from mail.ts by ADR
 * 0024). The learner's half of mail: the outcome check-in's four questions in
 * Codex's exact words (CODEX-DRAFT-STAGE-3-COPY §4), the form's open-or-closed
 * answer, and the unsubscribe link's answer. These are what the public web
 * app's two token pages read and post, so they sit at the contracts root.
 * Everything else about mail is mail.ts, a server-side subpath the public
 * bundle never loads (its source, comments and all, would ride into the
 * source map beside the bundle).
 *
 * Nothing here carries an address or names who a token belongs to.
 */
// ---------------------------------------------------------------- the outcome check-in (Codex, §4)
/**
 * The four questions and their options, in Codex's order and words
 * (CODEX-DRAFT-STAGE-3-COPY-2026-10-07.md §4), as keys: the labels the form
 * shows are the words themselves, held in the web's copy. Single choice,
 * nothing selected in advance, no free text, "rather not say" everywhere.
 * The database holds the same vocabularies as CHECK constraints (0043).
 */
export const OUTCOME_QUESTIONS = ["interviewed", "how_far", "offer", "helped"];
export const OUTCOME_ANSWERS = {
    interviewed: ["yes", "no", "rather_not_say"],
    how_far: ["no_interviews", "first_round", "later_rounds", "final_round", "rather_not_say"],
    offer: ["yes", "no", "still_waiting", "rather_not_say"],
    helped: ["yes_a_lot", "yes_a_little", "no", "not_sure", "did_not_interview", "rather_not_say"],
};
export const OutcomeInterviewedSchema = z.enum(OUTCOME_ANSWERS.interviewed);
export const OutcomeHowFarSchema = z.enum(OUTCOME_ANSWERS.how_far);
export const OutcomeOfferSchema = z.enum(OUTCOME_ANSWERS.offer);
export const OutcomeHelpedSchema = z.enum(OUTCOME_ANSWERS.helped);
/** POST /check-in/:token's body: one answer to each of the four questions. */
export const OutcomeCheckinAnswersSchema = z.strictObject({
    interviewed: OutcomeInterviewedSchema,
    how_far: OutcomeHowFarSchema,
    offer: OutcomeOfferSchema,
    helped: OutcomeHelpedSchema,
});
/**
 * GET /check-in/:token: the form is open only while the OUTCOME_CHECKIN
 * consent holds now, no answer exists for that season, and the season's
 * check-in window is still open (WINDOW_CLOSED, 2026-10-11: once the window
 * has closed the season's totals are frozen and a late answer would be kept
 * and counted nowhere, which the form's own privacy note does not allow; a
 * season the calendar no longer names is closed the same way), and the
 * account's deletion is not pending (ACCOUNT_CLOSING, 2026-10-21: nothing is
 * written into an account that is going; keeping it opens the form again);
 * otherwise the reason, so the page can say which.
 */
export const CheckinClosedReasonSchema = z.enum(["ANSWERED", "WINDOW_CLOSED", "NO_CONSENT", "ACCOUNT_CLOSING"]);
export const CheckinStateSchema = z.discriminatedUnion("open", [
    z.strictObject({ season: TargetSeasonSchema, open: z.literal(true), reason: z.null() }),
    z.strictObject({ season: TargetSeasonSchema, open: z.literal(false), reason: CheckinClosedReasonSchema }),
]);
/** POST /u/:token, and its stop-all POST /u/:token/all (2026-10-21), answer the same whether or not anything changed, so a token proves nothing about an address. */
export const UnsubscribeResultSchema = z.strictObject({ ok: z.literal(true) });
//# sourceMappingURL=mail-links.js.map